import Box from "@mui/material/Box"


export default function BooleanLabel({
    bool,
}: {
    bool: boolean,
}) {

    return (
        <Box p={1} display="flex" gap={1} alignItems="center">
            {bool ?
                <Box sx={{
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    backgroundColor: 'success.light',
                }}/>
                :
                <Box sx={{
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    backgroundColor: 'error.light',
                }}/>
            }
            {bool ?
                <Box>Ano</Box>
                :
                <Box>Ne</Box>
            }
        </Box>
    )
}
